import './App.css';
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import routes from "./routes/routes";
import { Suspense } from 'react';
import AdminLayout from './shared/Layout/AdminLayout.jsx';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route, indexRoute) => {
          return (
            <Route
              path={route.path}
              element={
                <Suspense fallback={<span>Loading...</span>}>
                  {
                    route.path !== '/' ?
                      <AdminLayout><route.component /></AdminLayout>
                      :
                      <route.component />
                  }
                </Suspense>
              }
              key={indexRoute}>
            </Route>
          );
        })}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
